var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Chart"},[_c('highcharts',{attrs:{"options":{
      title: false,
      legend: false,
      chart: {
        backgroundColor: 'rgba(0,0,0,0)',
        marginTop: _vm.canExport ? 45 : 16,
        marginLeft: 0,
        marginRight: 0,
        marginBottom: 16,
      },
      time: { useUTC: false },
      xAxis: {
        title: _vm.axisTitles
          ? {
              text: ("Time (" + (Intl.DateTimeFormat().resolvedOptions().timeZone) + ")"),
            }
          : null,
        type: 'datetime',
        labels: {
          align: 'left',
          x: 5,
          y: 14,
          format: '{value:%l:%M %p}',
        },
        showLastLabel: false,
        tickLength: 16,
      },
      yAxis: {
        title: _vm.axisTitles ? { text: 'Hashrate' } : null,
        labels: {
          align: 'left',
          x: 0,
          y: -5,
          formatter: function () {
            return _vm.formatHashrate(this.value, 3);
          },
          style: {
            textOutline: '2px rgba(255,255,255,0.6)',
          },
        },
        maxPadding: 0.02,
        endOnTick: false,
        tickAmount: _vm.tickAmount || 4,
        min: 0,
      },
      tooltip: {
        borderRadius: 8,
        borderWidth: 1,
        shadow: false,
        shared: true,
        backgroundColor: 'rgba(255,255,255,0.85)',
        borderColor: 'rgba(0, 20, 40, 0.15)',
        formatter: function () {
          return this.points.reduce(
            function (s, point) {
              return s + '<br/> Hashrate: ' + _vm.formatHashrate(point.y, 3);
            },
            new Date(this.x).toLocaleDateString(undefined, {
              year: 'numeric',
              month: 'long',
              day: 'numeric',
              hour: 'numeric',
              minute: 'numeric',
            })
          );
        },
      },
      series: [
        {
          type: 'line',
          name: 'Hashrate',
          data: _vm.data,
          marker: {
            radius: _vm.pointRadius || 0,
            fillColor: 'rgba(0, 127,255, 0.8)',
          },
          color: 'rgba(0, 127,255, 0.6)',
        } ],
      exporting: {
        enabled: _vm.canExport,
        buttons: {
          contextButton: {
            y: -12,
            menuItems: ['downloadCSV', 'downloadXLS'],
          },
        },
      },
    }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }